export const FPR_CLASS_MODULE_MAPPING = {
  FPR_CLP: ".fpr-clp",
  FPR_FORM: ".fpr-long-form",
  FPR_REPORT_PREVIEW: ".fpr-report-preview",
  FPR_REPORT_PREVIEW_NO_SCORE: ".fpr-report-preview-no-score",
  FPR_DASHBOARD: ".fpr-dashboard",
  FPR_PAYMENTS: ".fpr-payments",
  FPR_ERROR: ".fpr-error",
} as const;

// Cookie/Storage keys
export const CS_REQUEST_ID = "cs_request_id";

export const FPR_STAGES = {
  SHORT_FORM: "CS_APLF_SHORT",
  LONG_FORM: "CS_APLF",
  PREVIEW: "CS_CPMT",
  COMPLETE: "CS_CPLT",
  ERROR: "ERROR",
  PREVIEW_REPORT: "CS_FPR_REPORT",
} as const;

export const FPR_LANDING_PAGES = {
  SHORT_FORM: "CS_ALPF_SHORT",
  LONG_FORM: "APLF_FULLFORM",
  PRE_FILLED_LONG_FORM: "APLF_PREFILLED",
} as const;

export const ErrorConstants = {
  VERIFY_DETAILS: "VERIFY_DETAILS",
  PAYMENT_STATUS: "PAYMENT_STATUS",
  DEFAULT: "DEFAULT",
  PDF_DOWNLOAD_ERROR: "Pdf Download Error",
} as const;

export const FORM_INPUT_NAME = {
  CUSTOMER_FULLNAME: "customerFullName",
  PAN: "pan",
  DOB: "dob",
  PINCODE: "pinCode",
  CITY: "city",
  GSTIN: "gstin",
  NET_MONTHLY_SALARY: "netMonthlySalary",
  GENDER: "gender",
  EMPLOYMENT_TYPE: "employmentType",
} as const;

export const FORM_FIELDTYPE_MAP = {
  customerFullName: "text",
  pan: "text",
  dob: "tel",
  pinCode: "tel",
  city: "text",
  gstin: "text",
  netMonthlySalary: "tel",
} as const;

export const FPR_DATA_STORAGE_KEY = "subscriptionDetails";

export const FPR_CREDIT_CARD = "Credit Card";

export const CPR_ENTRY_POINT = "cprEntryPoint";

export const CPR_FORM_DATA_KEY = "cfdk";

export const CIBIL_SCORE_METER_TYPES = {
  PREVIEW_REPORT: "preview-report",
  DASHBOARD: "dashboard",
} as const;

export const CLEVERTAP_STATIC_VALUES = {
  JOURNEY_NAME: "CPR JOURNEY",
  CPR_CLP_PAGE: "CPR CLP PAGE",
  CPR_PDP_PAGE: "CPR PDP PAGE",
  CPR_HOMEPAGE_CLICKED: "CPR_HOMEPAGE_CLICKED",
  CPR_HOMEPAGE_VIEWED: "CPR_HOMEPAGE_VIEWED",
  CPR_APPLICATION_CLICKED: "CPR_APPLICATION_CLICKED",
  CPR_APPLICATION_VIEWED: "CPR_APPLICATION_VIEWED",
  YES: "YES",
  NO: "NO",
  NA: "NA",
  NEW_USER: "NEW USER",
  PAID: "PAID",
  SCORE_CHECKED: "SCORE CHECKED",
  EXPERIAN_PAGE: "EXPERIAN PAGE",
  PREVIEW_REPORT_PAGE: "REPORT PREVIEW PAGE",
  DASHBOARD_PAGE: "EXPERIAN SCORE DASHBOARD PAGE",
  ERROR_PAGE: "ERROR PAGE",
  VALID_ERROR_PAGE: "VALID_ERROR_PAGE",
  SYSTEM_ERROR_PAGE: "SYSTEM_ERROR_PAGE",
  WIDGET: "WIDGET",
  PERSONAL_DETAILS_PAGE: "PERSONAL DETAILS PAGE",
  PAYMENT_DETAILS_PAGE: "PAYMENT DETAILS PAGE",
  YOUR_EXPERIAN_SCORE: "YOUR EXPERIAN SCORE",
  RETRY: "RETRY",
  SUCCESS: "SUCCESS",
  FAQ_PAGE: "Updates and Announcements",
  ACTIVE_CP_SUBSCRIPTION: "ACTIVE_CP_SUBSCRIPTION_POP-UP",
  INFO_BUTTON_CLICKED: "INFO_BUTTON_CLICKED",
  TNC_ERROR: "PLEASE ACCEPT TERMS AND CONDITIONS TO AGREE",
  MULTIPLE_ERROR_MSG: "THERE ARE MUTIPLE ERRORS ON SCREEN",
  ERROR_MSG: "THERE IA A ERROR ON SCREEN",
  UNLOCK_REPORT_AT_500: "UNLOCK REPORT AT 500 (CTA at the bottom)",
  LEAVING_SO_SOON: "LEAVING SO SOON",
  LIFE_INSURANCE_DETAILS_SUBMITTED: "LIFE_INSURANCE_DETAILS_SUBMITTED",
  LIFE_INSURANCE_PAGE_VIEWED: "LIFE_INSURANCE_PAGE_VIEWED",
  MINIFORM_INSURANCE_DETAILS_SUBMITTED: "MINIFORM_INSURANCE_DETAILS_SUBMITTED",
  PDP_CARD: "TERM INSURANCE",
  VIEW_QUOTE: "VIEW QUOTE",
  ERROR_MODAL: "ERROR_MODAL",
} as const;

export const FPR_HANDLER_SOURCE = {
  FPR_FORM_WIDGET: "FPR_FORM_WIDGET",
  VIEW_DASHBOARD: "VIEW_DASHBOARD",
} as const;

export const CP_COOKIE_CONSTANTS = {
  cScore: "cScore",
  fsup: "fsup",
  cpss: "cpss",
  redirectionUrl: "redirectionUrl",
  planCode: "planCode",
  cpsd: "cpsd",
  default: "default",
  true: "true",
  ucnav: "ucnav",
  cp: "cp",
} as const;

export const CAMPAIGN_HEADER_VARIATION = {
  DEFAULT_HEADER: "defaultHeader",
  FPR_HEADER: "fprHeader",
  MICROSITE_HEADER: "micrositeHeader",
  BALIC_HEADER: "balicHeader",
} as const;

export const APP_SDK_CONSTANTS = {
  SUCCESS: "success",
  PAYMENT_RECEIVED: "Payment Received",
  PAYMENT_FAILED: "Payment Failed",
  CPR: "CPR",
};

export const CP_COMPONENT_STATE = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
} as const;

export const FEEDBACK_MODAL_STATE = {
  NONE: "NONE",
  EXIT: "EXIT",
  FEEDBACK: "FEEDBACK",
} as const;

export const PAYMENT_SUCCESS_CODES = [90, 97];

export const CPR_PDP_URL = "/credit-pulse-report";

export const CPR_CHECK_PAGE = "/credit-pulse-report-check";

export const PDP_BYPASS = "pdpbypass";
